export default "__VITE_ASSET__IhppmCam__"